// extracted by mini-css-extract-plugin
export default {"content":"layout_content__s8xJw","icon":"layout_icon__yxAR0","twitter":"layout_twitter__wx4US","linkedin":"layout_linkedin__byscc","youtube":"layout_youtube__PmvGI"};